 /* jshint esversion: 6 */
import Vue from 'vue';
import Router from 'vue-router';
import header from '@/components/header';
import footer from '@/components/footer';


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'first',
      redirect:'/home'
    },
    {
      path: '/home',
      name: '主页',
      component: ()=>import('@/view/home')
    },
    {
      path:'/course',
      name:'课程',
      component:()=>import('@/view/course'),
      meta: {
        requireAuth: false
      },
    },
    {
      path:'/broadcast',
      name:'课程播放',
      component:()=>import('@/view/course/broadcast'),
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/news/:id',
      name: '培训动态',
      component: () => import('@/view/home/news'),
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/enterExam',
      name: '考试首页',
      component: ()=>import('@/view/exam/enterExam'),
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/exam',
      name: '考试',
      component: ()=>import('@/view/exam'),
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/personal',
      name: '个人中心',
      component: ()=>import('@/view/personal'),
      redirect:'/personal/info',
      meta: {
        requireAuth: false
      },
      children:[
        {
          path: '/personal/info',
          name: '个人信息',
          component: ()=>import('@/view/personal/info'),
          meta: {
            requireAuth: false
          },
        },
        {
          path: '/personal/myCourse',
          name: '我的课程',
          component: ()=>import('@/view/personal/myCourse'),
          meta: {
            requireAuth: false
          },
        },
        {
          path: '/personal/myExam',
          name: '我的考试',
          component: ()=>import('@/view/personal/myExam'),
          meta: {
            requireAuth: false
          },
        },
        {
          path: '/personal/examRecord',
          name: '考试记录',
          component: ()=>import('@/view/personal/examRecord'),
          meta: {
            requireAuth: false
          },
        },
        {
          path: '/personal/creditSearch',
          name: '学时查询',
          component: ()=>import('@/view/personal/creditSearch'),
          meta: {
            requireAuth: false
          },
        },
        {
          path: '/personal/archives',
          name: '学习档案',
          component: ()=>import('@/view/personal/archives'),
          meta: {
            requireAuth: false
          },
        }
      ]
    },
    //完善用户信息
    {
      path: '/authentication',
      name: 'authentication',
      component:()=> import('@/view/authentication/index.vue')
    },
    {
      path: '/live',
      name: 'Live',
      component: ()=> import('@/view/live/index.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/courseDes',
      name: 'courseDes',
      component: ()=> import('@/view/course/courseDes.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/header',
      name: 'header',
      component: header
    },
    {
      path: '/footer',
      name: 'footer',
      component: footer
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js